module.exports = __webpack_public_path__ + "static/img/27.314b9be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/27.jpg
// module id = ZIbR
// module chunks = 0